<template>
    <div
        class="fixed inset-0 z-[1002] flex items-center justify-center bg-black/50"
    >
        <div class="relative w-full max-w-[1200px] max-h-[96vh] overflow-y-auto bg-white rounded-[20px] p-8 mx-4">
            <!-- 关闭按钮 -->
            <button
                class="absolute top-4 right-4 flex h-8 w-8 items-center justify-center rounded-full text-[#8993A4] hover:bg-[#F4F5F7] hover:text-[#020A1A] transition-colors"
                @click="onClose"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
            </button>

            <!-- 标题 -->
            <div class="mb-6 text-center">
                <h2 class="text-2xl font-semibold text-[#020A1A]">
                    {{ t('title.pickYourPlan') }}
                </h2>
                <p class="mt-2 text-sm text-[#8993A4]">
                    {{ t('subtitle.pickYourPlan') }}
                </p>
            </div>

            <!-- PlanDialog 内容 -->
            <PlanDialog :event-detail="props.eventDetail" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import PlanDialog from './PlanDialog.vue';
import { onMounted } from 'vue';
import { useTrack } from '../../composables/use-track';
import _ from 'lodash';

interface Props {
    callback: () => void;
    eventDetail?: Record<string, any>;
}

const props = defineProps<Props>();

const track = useTrack();

// 组件内部国际化配置
const MODAL_MESSAGES = {
    en: {
        title: {
            pickYourPlan: 'Pick your plan',
        },
        subtitle: {
            pickYourPlan: 'Choose the plan that works for you',
        },
    },
    cn: {
        title: {
            pickYourPlan: '选择计划',
        },
        subtitle: {
            pickYourPlan: '选择适合您的计划',
        },
    },
    tw: {
        title: {
            pickYourPlan: '選擇方案',
        },
        subtitle: {
            pickYourPlan: '選擇適合您的方案',
        },
    },
    jp: {
        title: {
            pickYourPlan: 'プランを選択',
        },
        subtitle: {
            pickYourPlan: 'あなたに合ったプランをお選びください',
        },
    },
} as const;

const { t } = useI18n({
    messages: MODAL_MESSAGES,
});

function onClose() {
    props.callback();
}

onMounted(() => {
    const fromTrigger = _.pick(props.eventDetail, ['trigger_source']);

    track({
        eventType: 'SS EUREKA UPGRADE PAGE',
        sourceType: 'pricing_page_view',
        moduleType: 'LS',
        eventDetail: {
            product_line: 'eureka_ls',
            from_trigger: fromTrigger || 'paywall',
            ...(props.eventDetail || {}),
        },
    })
})

</script>

<style scoped>
.modal-enter-active,
.modal-leave-active {
    transition: opacity 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
    opacity: 0;
}

.modal-enter-active .relative,
.modal-leave-active .relative {
    transition: transform 0.3s ease;
}

.modal-enter-from .relative,
.modal-leave-to .relative {
    transform: scale(0.95);
}
</style>
